import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CaseService } from '../shared/services/case.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-on-hold',
  templateUrl: './on-hold.component.html',
  styleUrls: ['./on-hold.component.scss']
})
export class OnHoldComponent implements OnInit {

  @Input() caseId: number = 0;
  isLoading: boolean = false;

  onHoldDetails= new UntypedFormGroup({
    onHoldReason: new UntypedFormControl()
  });

  constructor(
  public activeModal: NgbActiveModal,
  private caseService: CaseService) {

  }

  ngOnInit(): void {
  }

  putCaseOnHold(){

    this.isLoading = true;
    this.caseService.putCaseOnHold(this.caseId, this.onHoldDetails.value).subscribe(response => {

      this.activeModal.close(true);

      }, error => {

        var errorMessage = "Failed to put case on hold";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

      });

  }

  cancel(){
    this.activeModal.dismiss();
  }


}
